import { render, staticRenderFns } from "./XCardTitle.vue?vue&type=template&id=450b7f9a"
import script from "./XCardTitle.vue?vue&type=script&lang=js"
export * from "./XCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports